const marketingActions = {
  modal: {
    type: 'Тип',
    bonus: 'Платеж',
    discount: 'Компания',
    date: 'Дата',
    store: 'Магазин',
    country: 'Страна',
    products: 'Товары',
    name: 'Название',
    actionText: 'Текст действия',
    priceplans: 'Ценовые планы',
    storeMarketingAction: 'Добавить новое действие',
    updateMarketingAction: 'Обновить действие',
  },
  messages: {
    success: 'Действие успешно сохранено',
    destroy: 'Действие успешно удалено',
  },
  actions: 'Маркетинговые действия',
  showing: 'показывается',
  actionsOf: 'действия из',
  noActionsFound: 'Действия не найдено',
  addNew: 'Добавить новое действие',
};

export default marketingActions;
